import { ApplicationRef } from '@angular/core';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { ListViewImplementation } from './ListViewImplementation';

import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';

export class AudiosImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public customMetadata: any;
  public audiosnextLink: any;
  public flag = false;
  public previousLink: string = "";
  public docheignt: number = 0;
  public toppos: number = 0;
  public cdstr: ApplicationRef;
  public listService: any;
  public customSort: any;
  public sortedAudios:any=[];
  public multiSelect:any;
  public contextMenuService: any;
  containerHeightCalc:any;
  listImpl:any
  loggerService: any;
  db: IndexedDBModule;
  indexDBData:any="";
  static singleInstance:any = null;
  public currentPageNo = 0;
  public previousPageNo = -1;
  paginationService: any;
  
  constructor(private globalService) {
    this.router = this.globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();

  }

  public static getInstance(globalService):AudiosImplementation{
    if(this.singleInstance == null){
        this.singleInstance = new AudiosImplementation(globalService);
    }
    return this.singleInstance;
}


  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.loggerService = globalService.getLoggerServiceRef();
    this.db = IndexedDBModule.getInstance(globalService);
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.paginationService = globalService.getPaginationServiceRef();
  }

  setHeightForView(){
    var self = this;
    self.setHeightForContainer();
    $(window).resize(function () {
      self.setHeightForContainer();
    });
  }


  setHeightForContainer(){
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight?collapsedHeight:0
    if (!this.universalService.isMobileDevice) {
      setTimeout(() => {
        this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],65);
      }, 500);
    }else {
      setTimeout(() => {
        this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],(79 + collapsedHeight))
      }, 500);
    }    
  }

  getIndexDBStoreName(url) {

    if (url.includes("sort=%2BobjectName")) {
      return "AudiosMetadata_Name_Asc"
    } else if (url.includes("sort=%2DfileCreatedDate")) {
      return "AudiosMetadata_FileCreatedDate_Desc";
    }else if (url.includes("sort=%2DobjectName")) {
      return "AudiosMetadata_Name_Desc"
    } else if (url.includes("sort=%2BfileCreatedDate")) {
      return "AudiosMetadata_FileCreatedDate_Asc";
    } else if (url.includes("sort=%2DcreatedDate")) {
      return "AudiosMetadata_CreatedDate_Desc";
    } else if (url.includes("sort=%2BcreatedDate")) {
      return "AudiosMetadata_CreatedDate_Asc";
    }

  }

  async checkDataIndexDB(url) {
    if(this.universalService.activeRepo == ActiveRepo.SHARE)
      return false
    let storeName = this.getIndexDBStoreName(url);
    this.universalService.currentOpenIndexDBStoreforFile = storeName;
    this.universalService.currentOpenIndexDBStoreforFolder = "";
    
    var result = await this.db.getAllData(storeName,"AudioImplementation");

    if (result) {
      var suc = {
        "objects": result
      };
      var nextData = await this.db.getByKey('NextLink', storeName);
      if (nextData != undefined && nextData['nextLink']) {
        suc['nextLink'] = nextData['nextLink'];
      }
      return suc;
    }
    return false;
  }

  saveToIndexDB (url, suc) {
    if(this.universalService.activeRepo == ActiveRepo.SHARE)
      return ;
     var storeName = this.getIndexDBStoreName(url);
 
     this.db.bulkAdd(storeName, suc['objects']);
 
     if(suc['nextLink']) {
       var nextLinkObj = {
         'storeName': storeName,
         'nextLink': suc['nextLink']
       };
       this.db.update('NextLink', nextLinkObj);
     } else  {
        this.db.deleteByKey("NextLink",storeName);
     }
   }

   async fetchData(url){
    
    this.audiosnextLink = "";
    this.previousLink = "";
    this.currentPageNo = 0;
    this.previousPageNo = -1;
    this.paginationService.LOCAL_DB = {};
    this.universalService.objectsPreviewArray = [];
    this.universalService.scrollToTopIcon = false;
    this.universalService.audiofileslistsize = 0;
    this.universalService.nameSort=false
    if(url.includes("objectName")){
      this.universalService.nameSort = true
    }
    let currentTime = new Date().getTime()
    this.indexDBData = await this.checkDataIndexDB(url);
    if(!this.indexDBData) {
      this.universalService.showLoader = true;
      this.getAudiosApi(url);

    } else {
      this.paginationService.spliceAndSaveDataInLocalDB(this.indexDBData["objects"]);
      this.setNextAndPreviousLinks(this.indexDBData);
      this.getAudios(this.paginationService.getBufferDataForNextPage(this.currentPageNo));
      this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
      // this.getAudios(this.indexDBData);

    }
   }

   setNextAndPreviousLinks(suc){
    if (suc["nextLink"]) {
      this.audiosnextLink = suc["nextLink"]
      if (this.audiosnextLink.includes("sort=")) {
        if (this.audiosnextLink.includes("sort=+")) {
          this.audiosnextLink=this.audiosnextLink.replace("sort=+", "sort=%2B")
        }else if (this.audiosnextLink.includes("sort=-")) {
          this.audiosnextLink=this.audiosnextLink.replace("sort=-", "sort=%2D")
        }
      }
    } else {
      this.audiosnextLink = ""
    }
  }




  getAudiosApi(url) {
    this.http.get(url).subscribe(
      suc => {
        this.paginationService.spliceAndSaveDataInLocalDB(suc["objects"]);
        this.setNextAndPreviousLinks(suc);
        this.getAudios(this.paginationService.getBufferDataForNextPage(this.currentPageNo));
        this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        this.saveToIndexDB (url, suc);
      },
      err => {
        this.universalService.disableModalBackdrop();
        this.universalService.showErrorMessage(err);
      }
    )
  }

  async getAudios(objects) {
    if(objects.length == 0){
      this.loggerService.log("inside empty audios")
      this.universalService.emptyTab = true;
      this.universalService.showLoader = false;
      return
    }else{
      this.universalService.emptyTab = false;
    }
    this.universalService.audiofileslistsize = 0
    this.sortedAudios = [];
    this.universalService.sortByNameArray = []
    var audioList = this.customMetadata.segregateData(objects, "audio");
    this.universalService.mobilePlayList = [];
    if(this.universalService.nameSort){
      await this.sortAudiosByName(audioList)
    }else{
      await this.sortAudios(audioList);
    }
    if (this.universalService.currentTab == 'audio' && !this.universalService.isMobileDevice) {
      //this.universalService.showLoader = true;
      this.universalService.audiofileslistsize = this.universalService.audiofileslistsize + audioList.length;
      this.listImpl.decideListOptions('audio');
      this.listImpl.fetchAudiosView(audioList);
      
    }
    
    if (this.universalService.listView) {
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.multiSelect.bindMultiSelectLibrary("#audioWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
      this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
      AppEvents.multiSelectEvent.next({"dataArray":this.sortedAudios})
    }
  }

 
  sortAudios(audioList) {
    var sortParam = "createdDate";
    if(this.universalService.isMobileDevice && localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate) {
      sortParam = "uploaded";
    }
    var array = this.customSort.sortByDates(audioList, this.sortedAudios, this.universalService.sharedAudios,sortParam)
    this.sortedAudios = array[0];
    this.universalService.objectsPreviewArray = array[1];
    if(this.universalService.mobilePlayList.length>0)
      this.universalService.mobilePlayList.push(...array[1]);
    else
      this.universalService.mobilePlayList= array[1];
    this.universalService.showLoader = false;
    AppEvents.multiSelectEvent.next({"dataArray":this.universalService.mobilePlayList})
    return this.sortedAudios;
  }

  sortAudiosByName(audioList){
    var array  = this.customSort.sortByNames(audioList,this.universalService.sortByNameArray)
    this.sortedAudios = array[0];
    this.universalService.sortByNameArray = array[0];
    this.universalService.objectsPreviewArray = array[1];
    if(this.universalService.mobilePlayList.length>0)
      this.universalService.mobilePlayList.push(...array[1]);
    else
      this.universalService.mobilePlayList= array[1];
    if(this.universalService.sortByNameArray.length == 0){
      this.universalService.emptyTab = true;
      this.universalService.showLoader = false;
      return
    }else{
      this.universalService.emptyTab = false;
    }
    AppEvents.multiSelectEvent.next({"dataArray":this.universalService.mobilePlayList})
    setTimeout(() => {
      this.universalService.showLoader = false;  
    }, 10);
  }


  createUrlForNextLinkOnDesktop(url) {
    var options
    if(!this.universalService.isMobileDevice && this.universalService.showPreview){
      options = this.listService.audioPreviewOptions
    }else{
      options = this.listService.listOptions
    }
    if (options.api.getVerticalPixelRange().top == 0)
      this.universalService.scrollToTopIcon = false;
    else
      this.universalService.scrollToTopIcon = true;

    if(this.universalService.audiofileslistsize - options.api.getLastDisplayedRow() < 3 && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
      this.previousPageNo = this.currentPageNo;
      setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
        this.currentPageNo ++;
        let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
        await this.appendData(objList);
        this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
      }, this.paginationService.bufferTimeoutForFetchingData);
    }
    if (this.universalService.audiofileslistsize - options.api.getLastDisplayedRow() < 3) {
      if ((this.previousLink != this.audiosnextLink)) {
        this.previousLink = this.audiosnextLink
        if (this.audiosnextLink != "") {
          this.universalService.showLoader = true;
          this.fetchNextPageData(url);
        } else {

        }
      } else {

      }
    }
  }

  createUrlForNextLinkOnMobile(docheignt, toppos, url) {
    if (toppos == 0) {
      this.universalService.scrollToTopIcon = false;
    } else {
      this.universalService.scrollToTopIcon = true;
      let checkIfContaineris95PercScrolled = (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)

      if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
        this.previousPageNo = this.currentPageNo;
        setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
          this.currentPageNo ++;
          let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
          await this.appendData(objList);
          this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        }, this.paginationService.bufferTimeoutForFetchingData);
      }

      if (checkIfContaineris95PercScrolled && this.audiosnextLink != "" && this.previousLink != this.audiosnextLink) {
        this.previousLink = this.audiosnextLink
        if (this.audiosnextLink != "") {
          this.universalService.showLoader = true;
          this.fetchNextPageData(url)
        } else {

        }
      }
    }
  }

  fetchNextPageData(url) {
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
        async nextPageData => {
          if(nextPageData["objects"] && !self.paginationService.LOCAL_DB[self.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
            let bufferDataPresent = self.paginationService.checkIfBufferDataIsPresent();
            if(!bufferDataPresent){
              self.currentPageNo = Object.keys(self.paginationService.LOCAL_DB).length;
              self.previousPageNo = self.currentPageNo - 1;
              self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
              self.setNextAndPreviousLinks(nextPageData);
              let objList = await self.paginationService.getBufferDataForNextPage(self.currentPageNo);
              await self.appendData(objList);
              self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo);
              resolve({"resp":nextPageData});
              return;
            }
          }
          self.universalService.showLoader = false;
          self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
          self.setNextAndPreviousLinks(nextPageData);
          resolve({"resp":nextPageData})
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err)
        }
      )
    })
  }

  appendData(objectsList) {
    if(objectsList!=undefined && objectsList.length>0 && this.universalService.emptyTab){
      this.universalService.emptyTab = false;
    }
    var audioList = this.customMetadata.segregateData(objectsList, "audio");
    if (this.universalService.currentTab == 'audio' && !this.universalService.isMobileDevice) {
      this.universalService.audiofileslistsize = this.universalService.audiofileslistsize + audioList.length;
      this.listImpl.appendRowDataForAudios(audioList);
    } else {
      if(this.universalService.nameSort){
         this.sortAudiosByName(audioList)
      }else{
         this.sortAudios(audioList);
      }
      AppEvents.multiSelectEvent.next({"dataArray":this.sortedAudios})
    }
  }

  selectAll(event){
    this.listImpl.selectAll(event)
  }
  
}
